import { EnkCalendarMonth } from "./calendar-month"
import { IEnkCalendarViewProps } from "./calendar-types"
import { generateMonths } from "./utils"

export default function EnkYearView(props: IEnkCalendarViewProps) {
  const { selectedDate, currentLocale } = props

  const selectedYear = selectedDate.getFullYear()
  const months = generateMonths(selectedYear, selectedDate, currentLocale)

  return (
    <div>
      <div className="bg-white">
        <div className="mx-auto grid max-w-3xl grid-cols-1 gap-x-8 gap-y-16 px-4 py-16 sm:grid-cols-2 sm:px-6 xl:max-w-none xl:grid-cols-3 xl:px-8 2xl:grid-cols-4">
          {months.map((month) => (
            <section key={month.name} className="text-center">
              <h2 className="text-sm font-semibold text-gray-900">{month.name}</h2>

              <EnkCalendarMonth days={month.days} {...props} />
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
